<style lang="stylus">
    .store-box
        padding-left 56px
        padding-right 84px
        overflow-y scroll
        overflow overlay
        background-color #f1f3fb;
        flex 1
        &::-webkit-scrollbar
            width 8px
            pointer-events none
            background none
        &::-webkit-scrollbar-thumb
            background #D2D3D6
            border-radius 6px
        &::-webkit-scrollbar-track
            background #fff
        &::-webkit-scrollbar-track-piece
            background none
        &::-webkit-scrollbar-corner
            background none
        &.pc-cn-bg
            page_background()
            &::-webkit-scrollbar-track
                page_background()
        &.pcview-store
            background #fff !important
            &::-webkit-scrollbar-track
                background #fff !important
            .store-container
                background none !important
        &.store-onlineview
            background none !important
            &::-webkit-scrollbar-track
                background none !important
            .store-container
                background none !important

    .store-box-en
        padding 0px
        background #fff
        min-height calc(100% - 49px)

    .store-container
        margin-top 140px
        background-color #f1f3fb;
        flex 1
        overflow visible
        .works-count
            color: #000;
            font-size: 18px;
            font-weight: 400;
            display: flex;
            align-items: center;
            line-height: 1;
            padding-top 15px
            padding-bottom 10px
            justify-content: center;
            width: 100%;
            position: absolute;
            top: -140px;
            .number
                color: #0167FF;
                font-size: 26px;
                font-weight: 600;
                letter-spacing: 1px;
                margin-right 10px


    .store-container-en
        margin-top 0px
        background #fff
        font-family "Poppins", "Microsoft YaHei", -apple-system, blinkmacsystemfont, "Segoe UI", roboto, "Helvetica Neue", arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"



    .store-container--breadcrumb
        margin-top 28px
        margin-bottom 33px
        font-size 16px
        color #2A2A2A
        display flex
        justify-content flex-start
        align-items center

    .store-container--back
        display flex
        justify-content flex-start
        align-items center
        cursor pointer
        transition all $transition-time $ease-in-out

        &:hover
            color #00be84 !important

    .album-line
        margin-right 85px
        margin-bottom 15px
        height 32px
        display flex
        justify-content space-between
        align-items center
        font-size 16px

    .album-line--more
        background #EEEEEE
        border-radius 16px
        font-size 12px
        padding 0 15px 0 20px
        display flex
        align-items center
        height 32px
        cursor pointer
        transition all $transition-time $ease-in-out

        &:hover
            color #00be84 !important
            background #e8f9f3
    .sc-add-spin
        position relative
        height 100px
        background transparent
        &.sc-add-spin-en
            height auto
            padding-bottom 30px
            font-size 16px
        .txtC
            text-align center
        .ivu-spin-fix
            pointer-events none
            background transparent
        .sc-load-fail
            position absolute
            left 50%
            transform translateX(-50%)
            top 36px
            font-size 14px
            display flex
            flex-direction column
            justify-content center
            align-items center
            .load-fail
                margin-bottom 16px
            .reload-span
                display inline-block
                padding 6px 20px
                background-color var(--themeColor)
                color #fff
                border-radius 3px
                font-size 12px
                cursor pointer

    .publish-adbox
        position absolute
        right 10px
        top 15px
        object-fit contain
        z-index 1
        img
            width 100%
            cursor pointer
        .def-img
            cursor default !important
        .close-img
            position absolute
            width 10px
            height 10px
            right 14px
            top 10px
            cursor pointer

        .close-btn
            position absolute
            top 0
            right 8px
            width 16px
            height 30px
            p
                position absolute
                top 0
                right 0
                width 16px
                height 16px
                font-size 12px
                color #fff
                background #f2362a
                line-height 12px
                text-align center
                border-radius 50%
                border 1px solid #fff
                cursor pointer
                user-select none
            .publish-noRemind
                position absolute
                display none
                right 0
                top 20px
                min-width 95px
                white-space nowrap
                background #fff
                padding 5px 10px
                border-radius 3px
            &:hover
                .publish-noRemind
                    display block
        .adbox-btn
            position absolute
            left 0
            right 0
            bottom 35px
            margin auto
            width 70px
            height 22px
            text-align center
            line-height 22px
            color #353535
            background #ffbf27
            border-radius 3px
            font-size 12px
            cursor pointer
            user-select none
    .no-work
        text-align center
        padding-bottom 140px
        margin-top 5px
        @media screen and (min-height: 768px)
            margin-top 100px
        img
            display block
            margin 0 auto
        .notFound-title
            font-size 14px
            line-height 20px
            letter-spacing 1px
            color #222222
            text-align center
            margin-top 16px
        .notFound-btn
            display inline-block
            background #017FFF
            border-radius 6px
            height 28px
            padding 0 20px
            margin 0 auto
            margin-top 16px
            line-height 28px
            color #fff
            font-size 12px
            outline none
            cursor pointer
            pointer-events all

    .external-nonework, .external-end
        font-weight: bold;
        font-size: 18px;
        line-height: 55px;
        color: #000000;

    .no-search
        .titles
            font-weight: bold;
            font-size: 24px;
            line-height: 55px;
            span
                color var(--themeColor)
        .sub-title
            font-weight: 500;
            font-size: 14px;
            line-height: 24px;
            text-align: center;
            color: #666666;

    .store-box.dark-theme
        background #1e1e20 !important
        &::-webkit-scrollbar
            width 8px
            pointer-events none
            background none
        &::-webkit-scrollbar-thumb
            background #484849
            border-radius 6px
        &::-webkit-scrollbar-track
            background #1e1e20 !important
        .store-container
            background #1e1e20 !important
        .external-nonework, .external-end
            color #fff
        .notFound-title
            color #fff
        &.pcview-store
            background #222427 !important
            &::-webkit-scrollbar-track
                background #222427 !important
            .store-container
                background none !important
        .works-count
            color #fff
</style>

<template>
    <div
        class="store-box"
        :class="{
            'dark-theme': isPCDarkMode == 2,
            'store-box-en': !internal,
            'pc-cn-bg': isPC && internal,
            'pcview-store': isNewPcView,
            'store-onlineview': !isPC,
        }"
        ref="storeCon"
    >
        <div :class="{ 'pc-store': isPC && internal, 'store-container-en': !internal }" class="store-container">
            <template v-if="internal">
                <div class="works-count">
                    <div class="number">{{ worksCount }}</div>
                    模板，会员专享模板{{ mfreeWorksCount }}
                </div>
                <tplSearch :search-word="workFilter.search" @search="doSearch" @searchByTag="doSearchTag" />
                <recommendAlbum v-if="albumPageStatus == 'default'" />
                <albumDetail v-else-if="albumPageStatus == 'detail'" />
                <albumList v-else-if="albumPageStatus == 'list'" />

                <tplWorkClass v-show="albumPageStatus != 'list'" ref="workFilter" @on-filter="updateFilter" :showSpin="showLoadSpin" />

                <tplWaterfall v-show="albumPageStatus != 'list'" ref="waterfall" :works="works" type="center" />

                <Spin class="sc-add-spin">
                    <div v-if="failLoad" class="sc-load-fail">
                        <span class="load-fail">{{ $t("loadFailed") }}</span>
                        <span class="reload-span" @click="reload">{{ $t("reload") }}</span>
                    </div>
                    <Spin v-show="showAddSpin && !allWorkShowed" fix background="transparent" />
                    <div v-show="allWorkShowed" class="txtC">
                        <p style="color: #606060" v-if="works.length">{{ $t("theEnd") }}</p>
                        <div v-else-if="isFollowPage" class="no-work">
                            <template v-if="followStatus == 'noLogin'">
                                <img src="@/home/assets/img/null-icon/login-null.svg" alt="" />
                                <div class="notFound-title">{{ $t("followNologin") }}</div>
                                <div class="notFound-btn" @click="toLogin">{{ $t("toLogin") }}</div>
                            </template>
                            <template v-if="followStatus == 'noFollow' || followStatus == 'noFollowWork'">
                                <img src="@/home/assets/img/null-icon/follow-null.svg" alt="" />
                                <div class="notFound-title">{{ $t("followNofollow") }}</div>
                                <div class="notFound-btn" @click="toStore">{{ $t("toStore") }}</div>
                            </template>
                            <!-- <template v-if="followStatus == 'noFollowWork'">
                                <img src="@/home/assets/img/store/follow-nofollow.svg" alt="" />
                                <div class="notFound-title">{{ $t('followNoWork') }}</div>
                                <div class="notFound-btn" @click="toStore">{{ $t('toStore') }}</div>
                            </template> -->
                        </div>
                        <div v-else-if="workFilter.search != ''" class="no-work">
                            <img src="@/home/assets/img/null-icon/search-null.svg" alt="" />
                            <div class="notFound-title">没有找到与"{{ workFilter.search }}"相关的模板，换个关键词试试？</div>
                            <div class="notFound-btn" @click="toFeed">告诉我们</div>
                        </div>
                        <div v-else class="no-work">
                            <img src="@/home/assets/img/null-icon/search-null.svg" alt="" />
                            <div class="notFound-title">没有找到相关的模板？</div>
                            <div class="notFound-btn" @click="toAllPrice">更多</div>
                        </div>
                    </div>
                </Spin>
            </template>

            <template v-else>
                <div
                    class="worklist-content-en"
                    :style="{
                        overflow: templateSelect === 'tags' ? 'auto' : '',
                        height: templateSelect === 'tags' ? '100%' : '',
                    }"
                >
                    <div v-show="templateSelect === 'index'">
                        <tplSearchEn @search="doSearch" />
                        <tagSlide v-if="tagList.length" />
                        <workMenu :albumAction="albumAction" @on-filter="updateFilter" />
                        <workFilterBox @on-filter="updateFilter" />
                        <div class="worklist-showbox">
                            <div ref="con" class="waterfall-con">
                                <tplWaterfall ref="waterfall" :works="works" type="center" />
                            </div>

                            <div class="sc-add-spin sc-add-spin-en">
                                <div v-if="failLoad" class="sc-load-fail">
                                    <span class="load-fail">{{ $t("loadFailed") }}</span>
                                    <span class="reload-span" @click="reload">{{ $t("reload") }}</span>
                                </div>

                                <loading v-show="showAddSpin && !allWorkShowed" />
                                <div class="txtC" v-show="allWorkShowed">
                                    <img src="@/home/assets/img/noworks.png" v-if="!works.length" alt="" />
                                    <p class="external-end" v-if="works.length">{{ $t("theEnd") }}</p>
                                    <p class="external-nonework" v-else>
                                        {{ $t("noResult") }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <tags v-show="templateSelect === 'tags'" />
                    <tagInfo :key="tagId" v-if="templateSelect === 'tagInfo'" />
                </div>
            </template>

            <!-- <BackTop :height="10" :bottom="200" el-class="store-container">
            </BackTop> -->
            <!-- <ed-back-top el-class="store-container" /> -->
            <FloatMenu v-if="!isPlugin" />
            <PublishModal v-if="showPublish" />
            <FirstCloneFreeModal
                v-if="showFirstCloneFree"
                :type="firstCloneType"
                @closeModal="firstCloneEvent('closeModal')"
                @toVip="firstCloneEvent('toVip')"
                @clone="firstCloneEvent('clone')"
                @toUse="firstCloneEvent('toUse')"
            />
        </div>
    </div>
</template>

<script lang="ts">
    import axios from "axios";
    import "@/home/style/tplLayout.styl";

    import tplCenter from "../mixins/tplCenter";
    import { internal } from "@/public/utils/env.js";
    import tplWorkClass from "./Tpl/tplWorkClass.vue";
    import FloatMenu from "./Floatmenu.vue";
    import PublishModal from "./publishModal/publishModal.vue";
    import recommendAlbum from "./album/recommendAlbum.vue";
    import albumDetail from "./album/albumDetail.vue";
    import albumList from "./album/albumList.vue";
    import workMenu from "./en/workmenu.vue";
    import loading from "@/public/components/loading.vue";
    import tplSearch from "./Tpl/tplSearch.vue";
    import tplSearchEn from "./en/tplSearch.vue";
    import { Component, Prop, Vue, Mixins, Watch } from "vue-property-decorator";
    import FirstCloneFreeModal from "@/home/parts/vip/FirstCloneFreeModal.vue";

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            tplWorkClass,
            FloatMenu,
            PublishModal,
            recommendAlbum,
            albumDetail,
            albumList,
            tplSearch,
            tplSearchEn,
            workMenu,
            workFilterBox: () => import("./en/workfilter.vue"),
            tagSlide: () => import("./en/tagSlide.vue"),
            tags: () => import("./en/tags.vue"),
            tagInfo: () => import("./en/tagInfo.vue"),
            loading,
            FirstCloneFreeModal,
        },
    })
    export default class TempCenter extends Mixins(tplCenter) {
        requestCancel = null;
        currentPreSVGPages = [];
        currentPreSVGPageArgs = [];

        //是否显示主题区域的加载动画
        showLoadSpin = false;
        //是否显示底部loading动画
        showAddSpin = false;
        //所有作品显示完毕
        allWorkShowed = false;

        failLoad = false;
        reloadType = null;

        // workFilter : any = {
        //     suggest: false, //我的推荐
        //     follow: false, //我关注的
        //     offset: 0,
        //     count: 30,
        //     order: "PV", // TIME | PV | LIKE
        //     sort: "DESC", // DESC | ASC
        //     classId: 0,
        //     price: 1, // 1全部 2免费 3付费 4会员免费
        //     lang: "",
        //     search: "",
        //     tag: [],
        //     album: null,
        // }

        noRemind: boolean = false;
        showPromotionBtn: boolean = false;
        stayTime: number = 0;

        isFollowPage: boolean = false;
        followStatus: string = ""; // noFollow,noLogin,default
        getFollowDataing: boolean = false;
        blockUpdate = false;
        albumAction = false;

        get isNewPcView() {
            return this.isPC && this.$isBiggerVersion("13.0.0");
        }

        get workFilter() {
            return this.$store.state.workFilter;
        }
        get tagId() {
            return this.$store.state.tagId;
        }
        checkFollow(payload) {
            this.followStatus = "default";
            this.isFollowPage = true;
            if (!this.userInfo || !(this.userInfo && this.userInfo.islogin)) {
                this.followStatus = "noLogin";
                this.allWorkShowed = true;
                this.clearWaterfall();
                return;
            }
            if (this.$store.state.tplCenter.followIds.length == 0) {
                this.followStatus = "noFollow";
                this.allWorkShowed = true;
                this.clearWaterfall();
                return;
            }
            this.$store.commit("updateWorkFilter", payload);
            this.replaceWorks();
        }
        updateFilter(payload) {
            console.log("updateFilter", "---------------------");
            if (this.blockUpdate && this.internal) {
                // 特殊场景初始化，禁用自主触发更新
                return;
            } else if (this.blockUpdate && !this.internal) {
                this.albumAction = false;
                this.blockUpdate = false;
            }
            if (payload.order == "FOLLOW") {
                this.checkFollow(payload);
            } else {
                this.isFollowPage = false;
                console.log("update option", payload);
                this.$store.commit("updateWorkFilter", payload);
                this.replaceWorks();
            }
        }
        initWorkFilter() {
            this.$store.commit("updateWorkFilter", {
                suggest: false,
                follow: false,
                offset: 0,
                count: 30,
                order: "PV",
                sort: "DESC",
                classId: 0,
                price: 1,
                lang: this.internal ? "zh" : this.lang,
                search: "",
                tag: [],
                album: null,
            });
            this.$store.commit("toTplCenter", {
                name: "albumPageStatus",
                data: "default",
            });
        }
        doSearch(obj) {
            //显示主题区域loading动画
            const data = {
                search: obj.keyword,
                offset: 0,
            };
            if (!obj.stopResetClass) {
                Object.assign(data, {
                    classId: 0,
                });
            }
            this.$store.commit("updateWorkFilter", data);

            this.isFollowPage = false;
            if (obj.doSearch) {
                if (this.albumPageStatus != "default") {
                    this.$store.commit("toTplCenter", {
                        name: "activeAlbumID",
                        data: -1,
                    });
                    this.$store.commit("toTplCenter", {
                        name: "albumPageStatus",
                        data: "default",
                    });
                }

                this.showLoadSpin = true;
                this.allWorkShowed = false;

                this.replaceWorks();
                if (this.$refs.workFilter) (<any>this.$refs.workFilter).activeLabel = this.baseOrder;
            }
        }
        toLogin() {
            if (this.isPC) {
                (<any>window).$qt.jsCallUserLogin();
            } else {
                this.$bus.$emit("login");
            }
        }
        toStore() {
            this.$store.commit("setState", { type: "activeLv2", data: null });
            this.$store.commit("setState", { type: "activeLv3", data: null });
            this.$bus.$emit("initWorkClass");
            this.initWorkFilter();
            this.replaceWorks();
        }
        toFeed() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "Feedback",
            });
        }
        toAllPrice() {
            let type = "1";
            if (this.isPlugin) {
                type = "5";
            }
            this.$bus.$emit("setFilterPrice", type);
        }
        doSearchTag(tag) {
            //显示主题区域loading动画
            this.$store.commit("updateWorkFilter", {
                tag: [tag],
                offset: 0,
            });

            this.showLoadSpin = true;
            this.allWorkShowed = false;

            this.replaceWorks();
            (<any>this.$refs.workFilter).activeLabel = this.baseOrder;
        }
        doRequest() {
            if (this.workFilter.suggest) {
                //每日推荐
                let params = {
                    id: this.params.id,
                    token: this.params.token,
                    price: this.workFilter.price,
                };
                return new Promise((resolve) => {
                    this.$edApi.getSuggestionWorks(params).then((data) => {
                        this.allWorkShowed = true;
                        resolve(data);
                    });
                });
            } else if (this.workFilter.follow) {
                //我关注的
                return new Promise((resolve) => {
                    let params = Object.assign(
                        {
                            id: this.params.id,
                            token: this.params.token,
                        },
                        this.workFilter
                    );
                    this.$edApi.getFollowedPublish(params).then(({ data }) => {
                        resolve(data);
                    });
                });
            } else {
                // 热门浏览 最新发布 最受欢迎
                return new Promise((resolve, reject) => {
                    let params = Object.assign(
                        {
                            user_id: this.userInfo ? this.userInfo.user_id : "",
                            token: this.userInfo ? this.userInfo.token : "",
                        },
                        this.workFilter
                    );
                    console.log(params);
                    this.$edApi
                        .getPublish(params)
                        .then(({ data }) => {
                            resolve(data);
                        })
                        .catch((err) => {
                            reject(err);
                        });
                });
            }
        }
        addWorks() {
            //显示底部loading动画
            this.showAddSpin = true;
            this.count = 20;
            this.failLoad = false;
            this.doRequest().then((data: any) => {
                //没有数据说明到底了
                if (data.length == 0) {
                    this.allWorkShowed = true;
                    this.showAddSpin = false;
                    this.isAdding = false;
                    return;
                }
                // this.workFilter.offset += data.length;
                this.$store.commit("updateWorkFilter", {
                    offset: this.workFilter.offset + data.length,
                });
                this.showAddSpin = false;
                this.updateWaterfall({
                    works: data,
                    noCache: null,
                    callback: () => {
                        if (data.length < 20) {
                            //小于20个说明已全部显示
                            this.allWorkShowed = true;
                        }
                        this.isAdding = false;
                    },
                });
            });
        }
        replaceWorks() {
            //显示主题区域loading动画
            this.doneReplaceWork = false;
            this.showLoadSpin = true;
            if (!this.internal) {
                this.showAddSpin = true;
            }
            this.allWorkShowed = false;
            this.clearWaterfall();
            (<HTMLElement>this.$refs.storeCon).scrollTop = 0;
            this.failLoad = false;
            let trackSearch = (result) => {
                let ts: any = this;
                this.$gaTrack("Template_searchCommunityWords", `userEnterWords: ${this.workFilter.search},isSearchResultEmpty: ${result}`);
                ts.$pcTrack(
                    JSON.stringify({
                        type: "Templates",
                        action: "searchCommunityWords",
                        event: "experience",
                        label: JSON.stringify({
                            user_enter_words: this.workFilter.search,
                            is_search_result_empty: result,
                        }),
                    })
                );
                this.sensors.track("searchCommunityWords", {
                    Catalogues: "Templates",
                    user_enter_words: this.workFilter.search,
                    is_search_result_empty: result,
                    platform: this.isPC ? "desktop" : "online",
                });
            };
            this.doRequest()
                .then((data: any) => {
                    this.showLoadSpin = false;
                    this.clearWaterfall();
                    if (!this.internal) {
                        this.showAddSpin = false;
                    }

                    if (!data || data.length == 0) {
                        if (this.works.length == 0) {
                            this.allWorkShowed = true;
                        }
                        //没有数据说明搜索不到相关内容
                        this.showLoadSpin = false;
                        if (!this.internal) {
                            this.showAddSpin = false;
                        }
                        this.$edMessage.error(this.$t("notFound"));
                        if (this.workFilter.search) {
                            trackSearch("noResultFound");
                        }
                        if (this.isFollowPage && this.$store.state.tplCenter.followIds.length != 0) {
                            this.followStatus = "noFollowWork";
                        }
                        this.doneReplaceWork = true;
                        return;
                    }
                    this.$store.commit("updateWorkFilter", {
                        offset: this.workFilter.offset + data.length,
                    });
                    if (this.workFilter.search) {
                        trackSearch("findResult");
                    }
                    this.updateWaterfall(
                        {
                            works: data,
                            noCache: null,
                            callback: () => {
                                if (data.length == 0) {
                                    //小于30个说明搜索结果已全部显示
                                    this.allWorkShowed = true;
                                }
                                this.doneReplaceWork = true;
                            },
                        },
                        true
                    );
                })
                .catch((err) => {
                    if (err.message.startsWith("timeout")) {
                        this.showLoadSpin = false;
                        if (!this.internal) {
                            this.showAddSpin = false;
                        }
                        this.failLoad = true;
                        this.reloadType = 0;
                    }
                });
        }
        reload() {
            if (this.reloadType == 0) {
                this.replaceWorks();
                this.failLoad = false;
            }
        }
        doneReplaceWork = false;
        scrollToAdd() {
            this.$store.commit("setState", {
                type: "reportMenu",
                data: false,
            });

            let con = <HTMLElement>this.$refs.storeCon;
            if (!this.doneReplaceWork) return;
            if (this.isAdding || this.workFilter.suggest) return;
            var scrollTop = con.scrollTop;
            if (this.$store.state.templateSelect !== "index") return;
            if (con.scrollHeight - (scrollTop + con.offsetHeight) < 30) {
                if (this.allWorkShowed || this.workFilter.order == "HOT") return;
                this.isAdding = true;
                this.addWorks();
            }
        }
        scrollGetData() {
            //处理滚动到底部后继续加载图片
            let con = <HTMLElement>this.$refs.storeCon;
            con.addEventListener("scroll", this.scrollToAdd);
        }
        showUserWorks(id) {
            if (!id) return;
            this.$store.commit("toTplCenter", {
                name: "showUserWorks",
                data: true,
            });

            this.$store.commit("toVisitUser", {
                id,
            });
        }
        viewWorkById(workId) {
            this.$edApi
                .getWorkInfo({
                    id: 0,
                    workId,
                    platform: this.$store.state.publicStore.runPlatform,
                })
                .then((data) => {
                    console.log("get workinfo success");

                    this.$store.commit("toActiveWork", data);
                    this.$store.commit("toTplCenter", {
                        name: "previewContext",
                        data: "center",
                    });

                    let query = location.search && new URLSearchParams(location.search.slice(1));
                    if (query && query.has("noClone")) return;

                    if (this.params && this.params.islogin) {
                        this.$bus.$emit("doClone");
                    } else {
                        this.$bus.$on("loginSucc", () => {
                            this.$bus.$emit("doClone");
                        });
                    }
                });
        }

        get vipState() {
            if (this.isPC) {
                return this.$store.state.pcVip;
            } else {
                return this.$store.state.publicStore.vip;
            }
        }
        get isOldVersion() {
            if (!this.pcVersion) {
                return false;
            }
            let arr = this.pcVersion.split(".");
            if (arr[1] < 1 || (arr[1] == 1 && arr[2] == 0)) {
                return true;
            } else {
                return false;
            }
        }
        get pcVersion() {
            return this.$store.state.pcVersion;
        }

        getAlbum() {
            console.log("getAlbum");
            // let lang = this.lang;
            // if(!['zh', 'en', 'fr', 'de', 'jp', 'es'].includes(lang)){
            //     lang = 'en';
            // }
            this.$edApi
                .getAlbumList({ lang: "zh" })
                .then((e) => {
                    console.log(e);
                    this.$store.commit("toTplCenter", {
                        name: "albumList",
                        data: e,
                    });
                    if (this.albumAction) {
                        if (!this.internal) {
                        } else {
                            this.albumAction = false;
                            this.blockUpdate = false;
                            this.$bus.$emit("toAlbum", 2028); // 符号素材专辑
                        }
                    }
                    setTimeout(() => {
                        // 设置语言冲突，延后执行
                        let tempUrl = location.href.replace(/[\&|\?]action\=[^\&]*/, "");
                        history.replaceState(history.state, "", tempUrl);
                    }, 500);
                })
                .catch((e) => {
                    this.blockUpdate = false;
                });
        }
        get userInfo() {
            return this.$store.state.userInfo;
        }
        get showPublish() {
            return this.$store.state.showPublish;
        }
        set showPublish(v) {
            this.$store.commit("setState", {
                type: "showPublish",
                data: v,
            });
        }
        get pcLang() {
            return this.$store.state.pcLang;
        }
        get albumPageStatus() {
            return this.$store.state.tplCenter.albumPageStatus;
        }
        get baseOrder() {
            return this.$store.state.baseOrder;
        }
        show520() {
            let isShow = false;
            let saveShow = localStorage.getItem("buy618");
            if (new Date().getTime() < new Date("2021-06-30 23:59:59").getTime() && !saveShow) {
                isShow = true;
            }
            this.$store.commit("setState", {
                type: "buy618",
                data: isShow,
            });
        }
        trackWhichTime() {
            let whichTime = ~~localStorage.getItem("whichTime") || 1;
            this.sensors.track("enterCommunityTimes", {
                Catalogues: "Templates",
                whichTime: whichTime,
                platform: this.isPC ? "desktop" : "online",
            });
            localStorage.setItem("whichTime", "" + whichTime++);
        }
        //生命周期
        mounted() {
            this.$store.commit("setState", {
                type: "trackTemplateWay",
                data: "fromCommunity",
            });
            if (this.$route.name == "Store") {
                this.sensors.track("TemplateCommunity", {
                    Catalogues: "Templates",
                    platform: "online",
                });
            } else if (this.$route.name == "NewPage") {
                this.sensors.track("TemplateCommunity", {
                    Catalogues: "Templates",
                    platform: "desktop",
                });
            }
            this.stayTime = new Date().getTime();
            this.show520();
            this.initWorkFilter();
            this.$store.commit("setState", {
                type: "baseOrder",
                data: this.internal ? "PV" : "TIME",
            });

            this.getAlbum();
            this.scrollGetData();
            //根据url中的query做相应处理
            let query = location.search && new URLSearchParams(location.search.slice(1));
            if (query && query.has("userId")) {
                let userId = query.get("userId");
                this.showUserWorks(userId);
                this.replaceWorks();
            } else if (query && query.has("workId")) {
                let workId = query.get("workId");
                this.viewWorkById(workId);
            } else {
                //pc可能会加theme之类的query
                // this.replaceWorks();
            }
            this.$bus.$on("updateWorkIds2", (payload) => {
                let { id, type } = payload;
                for (let i = 0; i < this.works.length; i++) {
                    if (this.works[i].id == id) {
                        switch (type) {
                            case "like": {
                                this.works[i].like = this.works[i].like - 0 + 1;
                                break;
                            }
                            case "dislike": {
                                this.works[i].like -= 1;
                                break;
                            }
                            case "collect": {
                                this.works[i].collect = this.works[i].collect - 0 + 1;
                                break;
                            }
                            case "discollect": {
                                this.works[i].collect -= 1;
                                break;
                            }
                        }
                    }
                }
            });
            (<any>window).$qt && (<any>window).$qt.jsCallWebUIDisplay && (<any>window).$qt.jsCallWebUIDisplay(); // 通知客户端ui渲染完成
        }
        async getDataAfterLogin() {
            //获取点赞和收藏数据
            // this.$store.dispatch("getIds");
            //获取已购买的作品
            // this.$store.dispatch("getBoughtWorks");
            //获取自己的兴趣
            // this.$store.dispatch("getOwnInterest");
            //如果已登录，获取关注的用户
            // this.$store.dispatch("getOwnRelationships");

            return Promise.all([this.$store.dispatch("getIds"), this.$store.dispatch("getBoughtWorks"), this.$store.dispatch("getOwnRelationships")]);
        }
        @Watch("userInfo.user_id")
        onLoginChanged(val, oldval) {
            if (this.isPC && val) {
                this.$bus.$emit("loginSucc-preview");
                this.getDataAfterLogin().then(() => {
                    console.log(this.workFilter, 2333);
                    if (this.workFilter.order == "FOLLOW" && this.followStatus == "noLogin") {
                        this.checkFollow(this.workFilter);
                    }
                });
            }
        }
        @Watch("userInfo.islogin")
        onPcLoginChanged(val, oldval) {
            if (this.isPC && !val) {
                // 退出登录关闭用户主页
                this.$store.commit("toTplCenter", {
                    name: "showUserWorks",
                    data: false,
                });
                this.$store.commit("userPage/setState", {
                    type: "clickUserWordIds",
                    data: [],
                });
            }
        }
        get tagList() {
            return this.$store.state.tagList;
        }
        get templateSelect() {
            return this.$store.state.templateSelect;
        }
        set templateSelect(value) {
            this.$store.commit("setState", {
                type: "templateSelect",
                value,
            });
        }
        @Watch("templateSelect")
        templateSelectChane() {
            if (this.templateSelect === "index") {
                this.$nextTick(() => {
                    this.masnory.layout();
                });
            }
        }
        getSpecialTags() {
            let lang = this.isPC ? this.pcLang : this.lang;
            this.$store.dispatch("getSpecialTags", lang);
        }

        @Watch("lang")
        changeLang() {
            if (!this.internal) {
                this.getSpecialTags();
                this.$store.commit("updateWorkFilter", {
                    offset: 0,
                    lang: this.lang,
                    search: "",
                    template_type: "1",
                });
                this.replaceWorks();
            }
        }
        showFirstCloneFree = false;
        firstCloneType = 0;
        firstCloneEvent(event) {
            if (event != "closeModal") {
                this.$bus.$emit("firstCloneFreeBusToClone", event);
            }
            this.showFirstCloneFree = false;
        }
        get worksCount() {
            return this.$store.state.worksCount;
        }
        get mfreeWorksCount() {
            return this.$store.state.mfreeWorksCount;
        }
        created() {
            this.$nextTick(() => {
                this.$store.commit("setState", { data: 3, type: "selectId" });
            });
            let action = new URLSearchParams(location.search).get("action");
            if (action == "symbolAlbum") {
                this.blockUpdate = true;
                this.albumAction = true;
            }
            this.$bus.$on("updateFilter", (data) => {
                this.updateFilter(data);
            });
            if (!this.internal) {
                this.getSpecialTags();
            } else {
                this.$store.dispatch("getWorksCount");
            }
            // if(!this.internal){
            //     let lang = this.isPC ? this.pcLang : this.lang;
            //     this.$store.dispatch("getTagClass", {lang});
            // }else{
            //     this.$store.dispatch("getTagClass");
            // }

            if (this.isPC) {
                document.addEventListener("gesturestart", (event) => event.preventDefault());
            }

            if (this.$validateLogin(false)) {
                this.getDataAfterLogin();
            } else {
                this.$bus.$on("loginSucc-store", () => {
                    this.getDataAfterLogin().then(() => {
                        if (this.workFilter.order == "FOLLOW" && this.followStatus == "noLogin") {
                            this.checkFollow(this.workFilter);
                        }
                    });
                });
            }
            this.trackWhichTime();
            this.$bus.$on("firstCloneFreeBusToStore", (type) => {
                this.firstCloneType = type;
                this.showFirstCloneFree = true;
            });
        }
        beforeDestroy() {
            console.log("dessss");
            this.$bus.$off("updateFilter");
            this.$bus.$off("updateWorkIds2");
            this.$bus.$off("loginSucc-store");
            this.$bus.$off("changeLang");
            this.$bus.$off("firstCloneFreeBusToStore");
            let stayTime = (new Date().getTime() - this.stayTime) / 1000 / 60;
            stayTime = stayTime < 1 ? Math.round(stayTime * 100) / 100 : Math.ceil(stayTime);
            this.stayTime = 0;
            this.$gaTrack("Template_stayInComminityTime", `duration: ${stayTime}m`);
            this.sensors.track("stayInComminityTime", {
                Catalogues: "Templates",
                duration: `${stayTime}m`,
                platform: this.isPC ? "desktop" : "online",
            });
            let con = <HTMLElement>this.$refs.storeCon;
            con.removeEventListener("scroll", this.scrollToAdd);
        }
    }
</script>

<i18n>
{
  "zh": {
    "searchInputPlaceholder": "请输入关键字搜索",
    "searchButtonText": "搜索",
    "hotTags": "热门标签：",
    "sortingMode": "排序方式：",
    "byView": "最多浏览",
    "byDate": "最新发布",
    "byLike": "最多点赞",
    "theEnd": "到底了",
    "noneWork": "暂无相关作品",
    "noResult": "未搜索到",
    "notFound": "未搜索到相关模板",
    "loadFailed": "加载失败, 请重试~",
    "reload": "重试",
    "noRemindLabel": "不再提示",
    "followNologin": "您还没有登录，请登录后查看..",
    "toLogin": "立即登录",
    "followNofollow": "您还没有关注作者，快去社区看看有没有喜欢的作者和模板吧！",
    "followNoWork": "关注作者还没有作品，快去社区看看有没有喜欢的作者和模板吧！",
    "toStore": "去社区看看"
  },
  "en": {
    "searchInputPlaceholder": "Search templates",
    "searchButtonText": "Search",
    "hotTags": "Popular Tags:  ",
    "sortingMode": "Sort by:",
    "byView": "Most viewed",
    "byDate": "Latest published",
    "byLike": "Most likes",
    "theEnd": "Bottom",
    "noneWork": "No related template",
    "noResult": "No Results",
    "notFound": "No results found. Try searching for something else.",
    "loadFailed": "Loading failed, please~",
    "reload": "try again",
    "noRemindLabel": "don't show this again",
    "followNologin": "Please sign in to access templates.",
    "toLogin": "Sign In",
    "followNofollow": "You have no following yet, go to the Template Gallery to explore more templates and see what creative users have shared.",
    "followNoWork": "There is no work by the writer followed yet, go to the Template Gallery to explore more templates and see what creative users have shared.",
    "toStore": "Go to Template Gallery"
  },
  "de": {
    "searchInputPlaceholder": "Bitte geben Sie Schlüsselwörter ein",
    "searchButtonText": "Suchen",
    "hotTags": "Hot Tags:  ",
    "sortingMode": "Sortieren nach:",
    "byView": "Mehr gelesen",
    "byDate": "Zuletzt veröffentlicht",
    "byLike": "Mehr gefällt",
    "theEnd": "Boden",
    "noneWork": "Keine relevante Werkzeuge gibt es mehr ",
    "noResult": "Keine Ergebnisse",
    "notFound": "Keine Ergebnisse gefunden. Versuchen Sie, nach etwas anderem zu suchen.",
    "loadFailed": "Hochladen fehlgeschlagen, bitte versuchen Sie später erneut~",
    "reload": "Wiederholen",
    "noRemindLabel": "don't show this again"
  },
  "fr": {
    "searchInputPlaceholder": "Rechercher les modèles",
    "searchButtonText": "Chercher",
    "hotTags": "Les tags populaires:  ",
    "sortingMode": "Trier par:",
    "byView": "Les plus vues",
    "byDate": "Les dernières publiées",
    "byLike": "Le plus aimé",
    "theEnd": "Bas",
    "noneWork": "Pas de travaux connexes",
    "noResult": "pas de résultat",
    "notFound": "Aucun résultat trouvé. Essayez de rechercher autre chose.",
    "loadFailed": "Le chargement a échoué, veuillez réessayer~",
    "reload": "Recommencez",
    "noRemindLabel": "don't show this again"
  },
  "es": {
    "searchInputPlaceholder": "Buscar plantillas",
    "searchButtonText": "Buscar",
    "hotTags": "Etiquetas populares:  ",
    "sortingMode": "Ordenar por:",
    "byView": "Mayores visualizaciones",
    "byDate": "Último publicado",
    "byLike": "Mayor cantidad de likes",
    "theEnd": "Final",
    "noneWork": "Sin trabajos relacionados",
    "notFound": "No se han encontrado resultados. Intente buscar algo más.",
    "noResult": "No hay resultados",
    "loadFailed": "Error al cargar, inténtelo de nuevo~",
    "reload": "Rever",
    "noRemindLabel": "don't show this again"
  },
  "jp": {
    "searchInputPlaceholder": "テンプレートを検索",
    "searchButtonText": "検索",
    "hotTags": "人気のタグ：",
    "sortingMode": "並び替え：",
    "byView": "最も閲覧数",
    "byDate": "最新の公開",
    "byLike": "最も気に入り",
    "theEnd": "最後です",
    "noneWork": "関連作品はありません",
    "noResult": "検索結果なし",
    "notFound": "検索結果が見つかりませんでした。他のキーワードでもう一度お試しください。",
    "loadFailed": "読み込めませんでした。再度お試しください~",
    "reload": "リトライ",
    "noRemindLabel": "don't show this again"
  },
  "pt": {
    "searchInputPlaceholder": "Buscar Modelos",
    "searchButtonText": "Buscar",
    "hotTags": "Tags populares:",
    "sortingMode": "Ordenar por:",
    "byView": "O Mais visto",
    "byDate": "O Última publicação",
    "byLike": "O Mais adorado",
    "theEnd": "Inferior",
    "noneWork": "Nenhum modelo relacionado",
    "noResult": "Sem Resultados",
    "notFound": "Nenhum resultado encontrado. Tente pesquisar por outra coisa.",
    "loadFailed": "Erro de carregamento. Por favor tente novamente~",
    "reload": "Tentar novamente",
    "noRemindLabel": "don't show this again"
  },
  "it": {
    "searchInputPlaceholder": "Parole chiavi di ricerca",
    "searchButtonText": "Ricerca",
    "hotTags": "Tag popolari：",
    "sortingMode": "Ordina per：",
    "byView": "I più visti",
    "byDate": "L'ultima pubblicazione",
    "byLike": "Il più amato",
    "theEnd": "Basso",
    "noneWork": "Nessun lavoro correlato",
    "notFound": "Nessun risultato trovato. Prova a cercare qualcos'altro.",
    "noResult": "Nessun Risultato",
    "loadFailed": "Caricamento non riuscito, riprova~",
    "reload": "Riprova",
    "noRemindLabel": "don't show this again"
  },
  "tw": {
    "searchInputPlaceholder": "請輸入關鍵字搜索",
    "searchButtonText": "搜尋",
    "hotTags": "熱門標籤：",
    "sortingMode": "排序方式：",
    "byView": "最多瀏覽",
    "byDate": "最新發佈",
    "byLike": "最多點讚",
    "theEnd": "到底了",
    "noneWork": "暫無相關作品",
    "noResult": "未搜尋到",
    "notFound": "未搜索到相關模板",
    "loadFailed": "加載失敗,請重試~",
    "reload": "重試",
    "noRemindLabel": "不再提示"
  },
  "kr": {
    "searchInputPlaceholder": "키워드 검색",
    "searchButtonText": "검색",
    "hotTags": "인기많은 태그：",
    "sortingMode": "정렬 기준：",
    "byView": "조회수 순",
    "byDate": "게시시간 순",
    "byLike": "좋아요수 순",
    "theEnd": "끝입니다~",
    "noneWork": "관련 작품이 없습니다~",
    "noResult": "검색되지 않음",
    "notFound": "해당 템플릿을 찾지 못했습니다.",
    "loadFailed": "로딩 실패, 다시 시도하세요~",
    "reload": "다시 시도하기",
    "noRemindLabel": "다시 알리지 않기",
    "followNologin": "템플릿에 액세스하려면 로그인하세요",
    "toLogin": "바로 로그인",
    "followNofollow": "아직 팔로잉한 작가가 없습니다. 커뮤니티에 가서 좋아하는 작가와 템플릿이 있는지 확인해 보세요！",
    "followNoWork": "팔로잉한 작가는 아직 작품이 없습니다. 커뮤니티에 가서 좋아하는 작가와 템플릿이 있는지 살펴보세요!",
    "toStore": "템플릿 갤러리로 이동합니다."
  },
  "id": {
    "searchInputPlaceholder": "Cari templat",
    "searchButtonText": "Cari",
    "hotTags": "Tag populer:  ",
    "sortingMode": "Urutkan berdasarkan:",
    "byView": "Paling banyak dilihat",
    "byDate": "Terakhir diterbitkan",
    "byLike": "Paling disukai",
    "theEnd": "Bawah",
    "noneWork": "Tidak ada templat terkait",
    "noResult": "Tidak Ada Hasil",
    "notFound": "Hasil tidak ditemukan. Coba cari yang lain.",
    "loadFailed": "Gagal memuat, silakan~",
    "reload": "coba lagi",
    "noRemindLabel": "jangan tampilkan lagi",
    "followNologin": "Masuk untuk mengakses templat.",
    "toLogin": "Masuk",
    "followNofollow": "Anda belum mengikuti apa pun. Buka Galeri Templat untuk mengeksplorasi templat lainnya dan melihat apa saja yang telah dibagikan oleh pengguna kreatif.",
    "followNoWork": "Belum ada tugas yang diikuti penulis. Buka Galeri Templat untuk menjelajahi templat lainnya dan melihat apa saja yang telah dibagikan oleh pengguna kreatif.",
    "toStore": "Buka Galeri Templat"
  }
}
</i18n>
